import TIK from 'constants/time/timeIntervalKind.const';
import {
  fromAnyDateToIso,
  fromAnyDateToIsoDayBgn,
  fromAnyDateToIsoDayEnd,
  fromAnyDateToIsoMonthBgn,
  fromAnyDateToIsoMonthEnd,
  fromAnyDateToIsoWeekBgn,
  fromAnyDateToIsoWeekEnd,
} from 'utils/converters/time/from.util';
import downToQuarter from 'utils/date/downToQuarter.util';
import { timeAdd1Day, timeAdd1Month, timeAdd1Week, timeSub1Day, timeSub1Month, timeSub1Week } from 'utils/date/manipulate.util';

const ERROR_UNSUPPORTED = 'Unsupported kind';
const ERROR_UNKNOWN = 'Unknown kind';
const ERROR_INVALID = 'Invalid date';

const meta = (options) => {
  const raw = options?.raw;
  const now = fromAnyDateToIso(raw);

  if (!now) return { error: ERROR_INVALID, now: '', expanded: false, raw };

  const expanded = options?.bgn !== now || options?.end !== now;

  return { expanded, now, raw };
};

const forWeekUntilNow = (raw) => {
  const bgn = fromAnyDateToIsoWeekBgn(raw);
  const end = fromAnyDateToIso(downToQuarter(raw));

  return { ...meta({ raw, bgn, end }), bgn, end };
};

const forMonthUntilNow = (raw) => {
  const bgn = fromAnyDateToIsoMonthBgn(raw);
  const end = fromAnyDateToIso(downToQuarter(raw));

  return { ...meta({ raw, bgn, end }), bgn, end };
};

const forDayThis = (raw) => {
  const bgn = fromAnyDateToIsoDayBgn(raw);
  const end = fromAnyDateToIsoDayEnd(raw);

  return { ...meta({ raw, bgn, end }), bgn, end };
};

const forWeekThis = (raw) => {
  const bgn = fromAnyDateToIsoWeekBgn(raw);
  const end = fromAnyDateToIsoWeekEnd(raw);

  return { ...meta({ raw, bgn, end }), bgn, end };
};

const forMonthThis = (raw) => {
  const bgn = fromAnyDateToIsoMonthBgn(raw);
  const end = fromAnyDateToIsoMonthEnd(raw);

  return { ...meta({ raw, bgn, end }), bgn, end };
};

const forMonthLast = (raw) => {
  const iso = timeSub1Month(raw);

  const bgn = fromAnyDateToIsoMonthBgn(iso);
  const end = fromAnyDateToIsoMonthEnd(iso);

  return { ...meta({ raw, bgn, end }), bgn, end };
};

const forMonthNext = (raw) => {
  const iso = timeAdd1Month(raw);

  const bgn = fromAnyDateToIsoMonthBgn(iso);
  const end = fromAnyDateToIsoMonthEnd(iso);

  return { ...meta({ raw, bgn, end }), bgn, end };
};

const forWeekLast = (raw) => {
  const iso = timeSub1Week(raw);

  const bgn = fromAnyDateToIsoWeekBgn(iso);
  const end = fromAnyDateToIsoWeekEnd(iso);

  return { ...meta({ raw, bgn, end }), bgn, end };
};

const forWeekNext = (raw) => {
  const iso = timeAdd1Week(raw);

  const bgn = fromAnyDateToIsoWeekBgn(iso);
  const end = fromAnyDateToIsoWeekEnd(iso);

  return { ...meta({ raw, bgn, end }), bgn, end };
};

const forDayLast = (raw) => {
  const iso = timeSub1Day(raw);

  const bgn = fromAnyDateToIsoDayBgn(iso);
  const end = fromAnyDateToIsoDayEnd(iso);

  return { ...meta({ raw, bgn, end }), bgn, end };
};

const forDayNext = (raw) => {
  const iso = timeAdd1Day(raw);

  const bgn = fromAnyDateToIsoDayBgn(iso);
  const end = fromAnyDateToIsoDayEnd(iso);

  return { ...meta({ raw, bgn, end }), bgn, end };
};

const expandDateRangeLimits = (options) => {
  const k = options?.kind;

  if (TIK.custom === k) return { error: ERROR_UNSUPPORTED, expanded: false, now: '', bgn: '', end: '' };

  const raw = options?.date;

  if (TIK.weekToDate === k) return forWeekUntilNow(raw);
  if (TIK.monthToDate === k) return forMonthUntilNow(raw);

  if (TIK.monthThis === k) return forMonthThis(raw);
  if (TIK.monthLast === k) return forMonthLast(raw);
  if (TIK.monthNext === k) return forMonthNext(raw);

  if (TIK.weekThis === k) return forWeekThis(raw);
  if (TIK.weekLast === k) return forWeekLast(raw);
  if (TIK.weekNext === k) return forWeekNext(raw);

  if (TIK.dayToday === k) return forDayThis(raw);
  if (TIK.dayYester === k) return forDayLast(raw);
  if (TIK.dayMorrow === k) return forDayNext(raw);

  return { error: ERROR_UNKNOWN, expanded: false, now: '', bgn: '', end: '' };
};

export default expandDateRangeLimits;
